import styled, { createGlobalStyle, css } from 'styled-components';

import { DrawerAnchorType } from '@/common/components/Drawer/Drawer';
import { customMediaQueries } from '@/common/constants/customMediaQueries';

export const GlobalStyle = createGlobalStyle<{
  isOpen?: boolean;
  scrollBarWidth?: number;
}>`
  body {
    overflow-y: ${({ isOpen }) => (isOpen ? 'hidden' : 'scroll')} !important;

    ${customMediaQueries.width1024} {
      &,
      & .header__wrapper > div:first-child {
        padding-right: ${({ isOpen, scrollBarWidth }) => (isOpen ? scrollBarWidth : 0)}px;
      }
    }
  }
`;

export const DrawerBox = styled.div<{
  isOpen?: boolean;
  anchor?: DrawerAnchorType;
  drawerWidth: number;
  scrollBarWidth: number;
  animationTime: number;
  viewPortHeight: number;
}>`
  position: fixed;
  z-index: 31;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: ${({ theme }) => theme.colorsV2.grayscale.white};
  overflow-y: scroll;
  border-radius: 12px 12px 0 0;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  max-height: ${({ viewPortHeight }) => viewPortHeight}dvh;
  bottom: ${({ isOpen, viewPortHeight }) => (isOpen ? 0 : -viewPortHeight)}dvh;
  @supports (not (height: 100dvh)) {
    max-height: ${({ viewPortHeight }) => viewPortHeight}vh;
    bottom: ${({ isOpen, viewPortHeight }) => (isOpen ? 0 : -viewPortHeight)}vh;
  }
  transition:
    bottom ${({ animationTime }) => animationTime}s ease-in-out,
    transform ${({ animationTime }) => animationTime}s ease-in-out,
    opacity ${({ animationTime }) => animationTime}s ease-in-out
      ${({ isOpen }) => (isOpen ? 0 : 1)}s;

  .drawer-element-title {
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody16.lg};
    text-align: left;
    font-weight: 600;
  }

  .drawer-element {
    margin-bottom: 12px;
  }

  .drawer-description {
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody16.lg};
    font-weight: 300;
    line-height: 20px;
    text-align: left;
    margin: 8px 0 32px 0;
  }

  ${customMediaQueries.width1024} {
    top: 0;
    height: 100%;
    width: ${({ drawerWidth }) => drawerWidth}px;
    max-height: unset;
    border-radius: 0;
    bottom: unset;

    ${({ anchor, isOpen, scrollBarWidth, drawerWidth }) => {
      switch (anchor) {
        case DrawerAnchorType.RIGHT:
          return css`
            right: 0;
            transform: translateX(${isOpen ? 2 * scrollBarWidth : drawerWidth}px);
            margin-right: ${isOpen ? scrollBarWidth : 0}px;
          `;
        case DrawerAnchorType.LEFT:
          return css`
            left: 0;
            transform: translateX(-${isOpen ? scrollBarWidth : drawerWidth}px);
            direction: rtl;
          `;
      }
    }}
  }
`;
